import { Typography } from '@breetometer/components';
import { Timeout } from 'BreetAssets';
import { INACTIVITY_WARNING_OFFSET } from 'BreetHelpers';
import { closeModal, useAppDispatch } from 'BreetRedux';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const DialogInactivityAlert = () => {
	const [milliseconds, setMilliseconds] = useState(INACTIVITY_WARNING_OFFSET);

	useEffect(() => {
		let intervalId: NodeJS.Timeout | undefined;

		if (milliseconds > 0) {
			intervalId = setInterval(() => {
				setMilliseconds((prevSeconds) => Math.max(0, prevSeconds - 1000));
			}, 1000);
		} else if (milliseconds === 0) {
			clearInterval(intervalId);
		}
		return () => {
			if (intervalId) {
				clearInterval(intervalId);
			}
		};
	}, [milliseconds]);

	const formattedTime = useMemo(() => {
		const totalSeconds = Math.floor(milliseconds / 1000);
		const minutes = Math.floor(totalSeconds / 60)
			.toString()
			.padStart(2, '0');
		const seconds = (totalSeconds % 60).toString().padStart(2, '0');
		return `${minutes}:${seconds}`;
	}, [milliseconds]);

	const dispatch = useAppDispatch();

	const stayLoggedIn = useCallback(() => {
		setMilliseconds(INACTIVITY_WARNING_OFFSET);
		dispatch(closeModal('inactivity'));
	}, [dispatch]);

	return (
		<div className='dialog-inactivity-alert bg-primary-500'>
			<div className='dialog-inactivity-alert_timeout bg-success-800'>
				<Typography
					as='h1'
					className='color-success-400'
				>
					{formattedTime}
				</Typography>
			</div>

			<div className='dialog-inactivity-alert_header'>
				<Timeout className='svg-dark' />
				<Typography
					as='h1'
					className='color-neutral-50'
				>
					Session Timeout Warning
				</Typography>
			</div>

			<div className='dialog-inactivity-alert_description'>
				<Typography
					as='p'
					className='color-primary-50'
				>
					You&apos;ll be logged out soon due to inactivity.&nbsp;&nbsp;
					<Typography
						as='span'
						onClick={stayLoggedIn}
					>
						Stay logged in
					</Typography>
				</Typography>
			</div>
		</div>
	);
};
